import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { SzamlazzhuService } from 'src/app/services/szamlazzhu/szamlazzhu.service';
import {
  MissingRefIdItem,
  SzamlazzhuInvoice,
} from 'src/app/services/szamlazzhu/types';
import { PayeePopupComponent } from '../../../../../shared/payee-popup/payee-popup.component';
import { MatRadioButton } from '@angular/material/radio';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-set-invoice-dialog',
  templateUrl: './set-invoice-dialog.component.html',
  styleUrls: ['./set-invoice-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatRadioButton,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatPaginator,
    DecimalPipe,
    DatePipe,
  ],
})
export class SetInvoiceDialogComponent implements OnInit {
  private dialogRef =
    inject<MatDialogRef<SetInvoiceDialogComponent>>(MatDialogRef);
  private szamlazzhuService = inject(SzamlazzhuService);

  readonly data = inject<MissingRefIdItem>(MAT_DIALOG_DATA);

  readonly dataSource = new MatTableDataSource<SzamlazzhuInvoice>();
  selectedInvoice?: SzamlazzhuInvoice;

  readonly displayedColumns = [
    'remaining_amount',
    'original_amount',
    'due_date_at',
    'invoice_number',
    'select',
  ] as const;

  @ViewChild(MatPaginator) set paginator(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
  }

  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  async ngOnInit(): Promise<void> {
    this.dataSource.sortingDataAccessor = (data, header) => {
      switch (header) {
        case 'remaining_amount':
        case 'original_amount':
        case 'due_date_at':
        case 'invoice_number':
          return data[header];
        case 'select':
          return this.selectedInvoice === data ? 1 : 0;
        default:
          return -1;
      }
    };

    await this.setInvoices();
  }

  selectInvoice(item: SzamlazzhuInvoice): void {
    this.selectedInvoice = item;
  }

  readonly submit = async () => {
    if (!this.selectedInvoice) {
      return;
    }

    try {
      await this.szamlazzhuService.setMissingRefId(
        this.data.uuid,
        this.selectedInvoice.id,
      );
      this.dialogRef.close();
    } catch (error: unknown) {
      console.error('Error while setting invoice id', error);
    }
  };

  readonly close = () => {
    this.dialogRef.close();
  };

  private async setInvoices(): Promise<void> {
    try {
      const result = await this.szamlazzhuService.getInvoicesOfMissingRefId(
        this.data.payee_case_reference_id,
      );
      this.dataSource.data = result.invoices;

      if (!this.selectedInvoice && result.invoices.length > 0) {
        this.selectedInvoice = result.invoices[0];
      }
    } catch (error) {
      console.error('Error while getting invoices', error);
    }
  }
}
